module.exports = {
	locales: [
		{
			locale: 'en',
			siteHandle: 'default',
			label: '🇺🇸 EN'
		},
		{
			locale: 'jp',
			siteHandle: 'jp',
			label: '🇯🇵 JA'
		},
	]
}
